module.exports = __webpack_public_path__ + "img/1470872504.c53d24f9.jpg";